
import React from "react"
import { Homepage } from './containers/homepage';


function App(props) {
  return <Homepage></Homepage>
  
}

export default App;
